<template>
  <div class="register__card-header">
    <div class="register__card-header-wrapper">
      <img src="/img/teacher-notification.svg" alt="notify" />
      <div class="register__card-notification">
        <h1><slot name="title" /></h1>
        <p><slot name="description" /></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterHeader'
}
</script>

<style scoped lang="scss">
.register__card {
  &-notification {
    position: absolute;
    top: 30px;
    left: 140px;
    right: 0;
    margin: auto;

    @include sm-and-down {
      top: 20px;
      left: 120px;
    }

    h1 {
      font-weight: bold;
      font-size: 24px;
      line-height: 24px;
      letter-spacing: 0.35px;
      color: $luchmara;

      @include sm-and-down {
        font-size: 20px;
      }
    }

    p {
      font-size: 15px;
      line-height: 18px;
      letter-spacing: 0.35px;
      color: $deepdark;
    }
  }

  &-header {
    position: absolute;
    top: -55px;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    @include sm-and-down {
      width: 336px;
      top: -40px;
    }

    &-wrapper {
      position: relative;

      @include sm-and-down {
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
